export const onSubscriptionComplete = (subscription: any) => {
	// Payment was successful.
	if (subscription.status === "active") {
		// Change your UI to show a success message to your customer.
		// Call your backend to grant access to your service based on
		// `result.subscription.items.data[0].price.product` the customer subscribed to.
		//here we do nothing because it's not save to open access to subscription from UI.
	}
}
